var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post)?_c('div',{staticClass:"page__post"},[(_vm.type === 'video')?[_c('PostVideo',{attrs:{"post":_vm.post}})]:(_vm.type === 'podcast')?[_c('PostPodcast',{attrs:{"post":_vm.post}})]:[_c('PostNormal',{attrs:{"post":_vm.post}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }